import axios from "axios";
import apiURL from "../env";

console.log("API URL in instance:", apiURL);

const instance = axios.create({
  baseURL: apiURL,
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.data) {
      const errorMessage = error.response.data.error || "An error occurred";
      if (errorMessage === "Token inválido.") {
        localStorage.removeItem("tt");
        localStorage.removeItem("un");
        localStorage.removeItem("ur");
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
